import Main from "../Main";
import BaseLayer from "./BaseLayer";
import ButtonLayer from "./ButtonLayer";
import AutoPlayCountPopup from "../entities/AutoPlayCountPopup";
import OptionsPopup from "../entities/OptionsPopup";
import getButtonBoundsList from "../helper/getButtonsBoundsList";
import AutoPlayStopBar from "../entities/AutoPlayStopBar";
import WinningFirework from "../entities/WinningFirework";


export default class UILayer extends BaseLayer {
  static instance: UILayer;
  private Main = Main.getInstance();

  constructor() {
    super();
    if (!UILayer.instance) {
      UILayer.instance = this;
    }
    const dim = this.Main.getDim();
    const coords = getButtonBoundsList(dim.width, dim.height);
    const isVertical = dim.width < dim.height;

    new ButtonLayer(coords,isVertical);
    new WinningFirework(coords.winningElement);
    new OptionsPopup();
    new AutoPlayCountPopup(coords.autoPlayButton, isVertical);
    new AutoPlayStopBar(coords.autoPlayButton);
  }
  static getInstance(): UILayer {
    return UILayer.instance;
  }
}